import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Reports/TrialBalance/TrialBalance.css";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import { useNavigate, useLocation } from "react-router-dom";
import PdfPreview from "../../../Common/PDFPreview";
import { jsPDF } from "jspdf";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { RingLoader } from 'react-spinners';
import { Typography } from '@mui/material';
import { FormaDateBalanceSheet } from "../../../Common/FormatFunctions/FormatDate"
import PrintButton from '../../../Common/Buttons/PrintPDF';

const apikey = process.env.REACT_APP_API;

const ProfitLossReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const { fromDate, toDate } = location.state || { fromDate: '', toDate: ''  };
  const searchParams = new URLSearchParams(location.search);
  const fromDate = searchParams.get("fromDate");
  const toDate = searchParams.get("toDate");
  const gcid = searchParams.get("gcid");
  const groupCode = searchParams.get("groupCode");
  const groupName = searchParams.get("groupName");
  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const Company_Name = sessionStorage.getItem("Company_Name")
  const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
  const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
  const newCompanyName = sessionStorage.getItem("newCompanyName")

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pdfPreview, setPdfPreview] = useState([]);

  const API_URL = `${apikey}/ProfitLoss_Report`;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    return `${day}/${month}/${year}`;
  };

   const docDate = new Date(fromDate);
    const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

    const displayCompanyName =
      docDate < cnameUpdatedDate
        ? newCompanyName 
        : Company_Name;

  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axios.get(API_URL, {
          params: {
            from_date: fromDate,
            to_date: toDate,
            Company_Code: companyCode,
            gcid : gcid
          },
        });
        setReportData(response.data);
      } catch (error) {
        console.error("Error fetching report:", error);
        setError("Error fetching report");
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [API_URL]);

  const handleExportToExcel = () => {
    try {
      const wb = XLSX.utils.book_new();
      const ws_data = [];


      ws_data.push([`${displayCompanyName} - Profit & Loss A/c - ${groupCode} - ${groupName}`]);
      ws_data.push([`Report Period: ${formatDate(fromDate)} to ${formatDate(toDate)}`]);
      ws_data.push([]);
      ws_data.push([
        "Purchase", "", "", "Amount",
        "",
        "Sale", "", "", "Amount"
      ]);

      const leftEntries = Object.entries(groupedReportData);
      const rightEntries = Object.entries(groupedReportDataRightside);
      const maxLen = Math.max(leftEntries.length, rightEntries.length);

      for (let i = 0; i < maxLen; i++) {
        const leftGroup = leftEntries[i]?.[1];
        const rightGroup = rightEntries[i]?.[1];

        ws_data.push([
          leftGroup?.items[0]?.BSGroupName || "",
          "", "", Number(leftGroup?.groupnetvalue?.toFixed(2)) || "",
          "",
          rightGroup?.items[0]?.BSGroupName || "",
          "", "", Number(rightGroup?.netgroupvalue?.toFixed(2)) || ""
        ]);

        const maxItems = Math.max(leftGroup?.items?.length || 0, rightGroup?.items?.length || 0);
        for (let j = 0; j < maxItems; j++) {
          const leftItem = leftGroup?.items[j];
          const rightItem = rightGroup?.items[j];

          ws_data.push([
            "",
            leftItem ? `   ${leftItem.Ac_Name_E}` : "",
            leftItem ? Number(Math.abs(leftItem.Balance).toFixed(2)) : "",
            "",
            "",
            "",
            rightItem ? `   ${rightItem.Ac_Name_E}` : "",
            rightItem ? Number(Math.abs(rightItem.Balance).toFixed(2)) : "",
            ""
          ]);
        }
      }

      const totalPurchase = Object.values(groupedReportData).reduce((a, b) => a + Math.abs(b.groupnetvalue), 0);
      const totalSale = Object.values(groupedReportDataRightside).reduce((a, b) => a + Math.abs(b.netgroupvalue), 0);
      const grossProfit = totalSale - totalPurchase;
      const grossLoss = totalPurchase - totalSale;

      ws_data.push(["Net Purchase", "", "", Number(totalPurchase.toFixed(2)), "", "Net Sale", "", "", Number(totalSale.toFixed(2))]);
      ws_data.push([
        "Gross Profit", "", "", grossProfit > 0 ? Number(grossProfit.toFixed(2)) : "",
        "", "Gross Loss", "", "", grossLoss > 0 ? Number(grossLoss.toFixed(2)) : ""
      ]);

      ws_data.push([
        "Total", "", "", Number((totalPurchase + (grossProfit > 0 ? grossProfit : 0)).toFixed(2)),
        "", "Total", "", "", Number((totalSale + (grossLoss > 0 ? grossLoss : 0)).toFixed(2))
      ]);

  
      const leftProfitEntries = Object.entries(groupReportDataProfitleftsideDebit);
      const rightProfitEntries = Object.entries(groupReportDataProfitrigthsidetsideCredit);
      const maxProfitLen = Math.max(leftProfitEntries.length, rightProfitEntries.length);

      for (let i = 0; i < maxProfitLen; i++) {
        const leftGroup = leftProfitEntries[i]?.[1];
        const rightGroup = rightProfitEntries[i]?.[1];

        ws_data.push([
          leftGroup?.items[0]?.BSGroupName || "",
          "", "", Number(leftGroup?.groupnetvalue?.toFixed(2)) || "",
          "",
          rightGroup?.items[0]?.BSGroupName || "",
          "", "", Number(rightGroup?.netgroupvalue?.toFixed(2)) || ""
        ]);

        const maxItems = Math.max(leftGroup?.items?.length || 0, rightGroup?.items?.length || 0);
        for (let j = 0; j < maxItems; j++) {
          const leftItem = leftGroup?.items[j];
          const rightItem = rightGroup?.items[j];

          ws_data.push([
            "",
            leftItem ? `   ${leftItem.Ac_Name_E}` : "",
            leftItem ? Number(Math.abs(leftItem.Balance).toFixed(2)) : "",
            "",
            "",
            "",
            rightItem ? `   ${rightItem.Ac_Name_E}` : "",
            rightItem ? Number(Math.abs(rightItem.Balance).toFixed(2)) : "",
            ""
          ]);
        }
      }

      const totalExpense = Object.values(groupReportDataProfitleftsideDebit).reduce((a, b) => a + Math.abs(b.groupnetvalue), 0);
      const totalIncome = Object.values(groupReportDataProfitrigthsidetsideCredit).reduce((a, b) => a + Math.abs(b.netgroupvalue), 0);
      const netProfit = (totalSale + totalIncome) - (totalPurchase + totalExpense);

  
      const totalAfterGrossLeft = totalPurchase + (grossProfit > 0 ? grossProfit : 0);
      const totalAfterGrossRight = totalSale + (grossLoss > 0 ? grossLoss : 0);

      ws_data.push(["Total", "", "", Number(totalExpense.toFixed(2)), "", "Total", "", "", Number(totalIncome.toFixed(2))]);
      ws_data.push([
        "Net Profit", "", "", netProfit > 0 ? Number(netProfit.toFixed(2)) : "",
        "", "Net Loss", "", "", netProfit < 0 ? Number((-netProfit).toFixed(2)) : ""
      ]);
      

      const totalDebit = totalPurchase + totalExpense + (netProfit > 0 ? netProfit : 0);
      const totalCredit = totalSale + totalIncome + (netProfit < 0 ? -netProfit : 0);
      
      ws_data.push([
        "Total Debit", "", "", Number(totalDebit.toFixed(2)),
        "", "Total Credit", "", "", Number(totalCredit.toFixed(2))
      ]);

      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      ws["!cols"] = [
        { wch: 22 },
        { wch: 30 },
        { wch: 18 },
        { wch: 18 },
        { wch: 5 },
        { wch: 22 },
        { wch: 30 },
        { wch: 18 },
        { wch: 18 },
      ];


      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let R = range.s.r; R <= range.e.r; R++) {
  
        if (R < 4) {
          for (let C = range.s.c; C <= range.e.c; C++) {
            const cell_ref = XLSX.utils.encode_cell({r: R, c: C});
            if (ws[cell_ref]) {
              ws[cell_ref].s = { 
                font: { bold: true }, 
                alignment: { horizontal: "center" } 
              };
            }
          }
        }
        

        const cellA = XLSX.utils.encode_cell({r: R, c: 0});
        if (ws[cellA] && (
          ws[cellA].v === "Net Purchase" || 
          ws[cellA].v === "Gross Profit" || 
          ws[cellA].v === "Gross Loss" ||
          ws[cellA].v === "Total" ||
          ws[cellA].v === "Net Profit" || 
          ws[cellA].v === "Net Loss" ||
          ws[cellA].v === "Total Debit" || 
          ws[cellA].v === "Total Credit"
        )) {
          for (let C = range.s.c; C <= range.e.c; C++) {
            const cell_ref = XLSX.utils.encode_cell({r: R, c: C});
            if (ws[cell_ref]) {
              ws[cell_ref].s = { 
                font: { bold: true }
              };
            }
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, ws, "Profit & Loss");
      XLSX.writeFile(wb, "ProfitLossReport.xlsx");
    } catch (err) {
      console.error("Excel Export Failed:", err);
    }
  };

  // const handleRowClick = (acCode, acname) => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     const url = `/getAllledger-report?fromDate=${encodeURIComponent(
  //       fromDate
  //     )}&toDate=${encodeURIComponent(toDate)}&acCode=${encodeURIComponent(
  //       acCode
  //     )}`;
  //     window.open(
  //       url,
  //       "_blank",
  //       "toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600"
  //     );
  //     setLoading(false);
  //   }, 500);
  // };

  const handleRowClick = (acCode, acname) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/ledger-report?fromDate=${encodeURIComponent(
        fromDate
      )}&toDate=${encodeURIComponent(toDate)}&acCode=${encodeURIComponent(
        acCode
      )}&acname=${encodeURIComponent(acname)}`;
      window.open(
        url,
        "_blank",
        "toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600"
      );
      setLoading(false);
    }, 500);
  };

  const groupReportData = (data) => {
    const groupedData = {};
    const filteredData = data.filter(
      (item) => item.group_Type === "T" && item.Balance > 0
    );
    filteredData.forEach((item) => {
      const key = `${item.group_Type} -${item.BSGroupName}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          items: [],
          totalQty: 0,
          groupnetvalue: 0,
        };
      }
      groupedData[key].items.push(item);
      groupedData[key].groupnetvalue +=
        parseFloat(item.Balance > 0 ? item.Balance : 0) || 0;
    });
    return groupedData;
  };

  const groupReportDataTradingrigthside = (data) => {
    const groupedData = {};
    const filteredData = data.filter(
      (item) => item.group_Type === "T" && item.Balance < 0
    );
    filteredData.forEach((item) => {
      const key = `${item.group_Type} -${item.BSGroupName}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          items: [],
          totalQty: 0,
          netgroupvalue: 0,
        };
      }
      groupedData[key].items.push(item);
      groupedData[key].netgroupvalue +=
        parseFloat(item.Balance < 0 ? item.Balance : 0) || 0;
    });
    return groupedData;
  };

  const groupReportDataProfitleftside = (data) => {
    const groupedData = {};
    const filteredData = data.filter(
      (item) => item.group_Type === "P" && item.Balance > 0
    );
    filteredData.forEach((item) => {
      const key = `${item.group_Type} -${item.BSGroupName}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          items: [],
          totalQty: 0,
          groupnetvalue: 0,
        };
      }
      groupedData[key].items.push(item);
      groupedData[key].groupnetvalue +=
        parseFloat(item.Balance > 0 ? item.Balance : 0) || 0;
    });
    return groupedData;
  };

  const groupReportDataProfitrigthside = (data) => {
    const groupedData = {};
    const filteredData = data.filter(
      (item) => item.group_Type === "P" && item.Balance < 0
    );
    filteredData.forEach((item) => {
      const key = `${item.group_Type} -${item.BSGroupName}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          items: [],
          totalQty: 0,
          netgroupvalue: 0,
        };
      }
      groupedData[key].items.push(item);
      groupedData[key].netgroupvalue +=
        parseFloat(item.Balance < 0 ? item.Balance : 0) || 0;

    });
    return groupedData;
  };

  const groupedReportData = groupReportData(reportData);
  const groupedReportDataRightside =
    groupReportDataTradingrigthside(reportData);

  const groupReportDataProfitleftsideDebit =
    groupReportDataProfitleftside(reportData);
  const groupReportDataProfitrigthsidetsideCredit =
    groupReportDataProfitrigthside(reportData);

  const handleBack = () => {
    navigate("/profit-loss-balance-sheet");
  };

  const renderPdf = (outputType = "blob") => {
    const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 20;
    const centerX = pageWidth / 2;
    const topSafeY = 36;
    const bottomSafeLimit = pageHeight - 40;

    const fontSize = 9;
    const lineHeight = 14;
    const labelWidth = 160;

    const leftTextX = margin;
    const leftAmtX = centerX - 40;
    const rightTextX = centerX + 10;
    const rightAmtX = pageWidth - margin - 40;

    let leftY = 0;
    let rightY = 0;

    let currentDividerStartY = 0;
    let pageCount = 1;

    const checkPageBreak = () => {
      if (leftY > bottomSafeLimit || rightY > bottomSafeLimit) {
        drawDivider(currentDividerStartY, Math.max(leftY, rightY));

        drawFooter();
        doc.addPage();
        pageCount++;
        currentDividerStartY = topSafeY;
        leftY = topSafeY;
        rightY = topSafeY;
      }
    };

    const drawDivider = (startY = topSafeY, endY = pageHeight - 40) => {
      if (typeof startY === "number" && typeof endY === "number") {
        doc.setLineWidth(0.5);
        doc.line(centerX, startY - 15, centerX, endY - 11);
      }
    };

    const drawHeaders = () => {
      if (pageCount > 1) return;
      let y = topSafeY;

      doc.setFontSize(10);
      doc.setFont("Arial", "bold");
      doc.text(`${displayCompanyName}`, centerX, y, { align: "center" });

      y += 10;
      doc.setFontSize(8);
      doc.setFont("Arial", "normal");

      const gstnText = `GSTN : ${Company_GSTNO}`;
      doc.text(gstnText, centerX, y, { align: "center" });

      const textWidth = doc.getTextWidth(gstnText);
      const underlineStartX = centerX - textWidth / 2;
      const underlineY = y + 1.5;

      doc.setLineWidth(0.3);
      doc.line(underlineStartX, underlineY, underlineStartX + textWidth, underlineY);

      y += 10;
      doc.setFontSize(8);
      doc.setFont("Arial", "bold");
      doc.text("Profit & Loss A/c", centerX, y, { align: "center" });

       y += 10;
      doc.setFontSize(8);
      doc.setFont("Arial", "bold");
      doc.text(`${groupCode}-${groupName}`, centerX, y, { align: "center" });

      y += 10;
      doc.setFont("Arial", "normal");
      doc.text(`${FormaDateBalanceSheet(fromDate)} to ${FormaDateBalanceSheet(toDate)}`, centerX, y, { align: "center" });

      y += 14;
      doc.setLineWidth(0.75);
      doc.line(margin, y, pageWidth - margin, y);

      y += 10;
      doc.setFontSize(fontSize + 1);
      doc.setFont("Arial", "bold");
      doc.text("Purchase", leftTextX, y);
      doc.text("Amount", leftAmtX + 35, y, { align: "right" });
      doc.text("Sale", rightTextX, y);
      doc.text("Amount", rightAmtX, y, { align: "right" });

      doc.line(margin, y + 4, pageWidth - margin, y + 4);
      drawDivider(y + 4);

      currentDividerStartY = y + 4;

      leftY = y + 12;
      rightY = y + 12;
    };

    const renderGroupPairwise = (leftGroups, rightGroups) => {
      const leftEntries = Object.entries(leftGroups);
      const rightEntries = Object.entries(rightGroups);
      const maxLen = Math.max(leftEntries.length, rightEntries.length);

      for (let i = 0; i < maxLen; i++) {
        checkPageBreak();

        // LEFT SIDE
        if (leftEntries[i]) {
          const [, group] = leftEntries[i];
          doc.setFont("arial", "bold");
          doc.text(group.items[0].BSGroupName.toUpperCase(), leftTextX, leftY);
          doc.text(formatReadableAmount(Math.abs(group.groupnetvalue) || 0), leftAmtX + 35, leftY, { align: "right" });
          leftY += lineHeight;

          doc.setFont("Arial", "italic");

          let groupStartY = leftY;

          // for (const item of group.items) {
          //   const lines = doc.splitTextToSize(item.Ac_Name_E.toUpperCase(), labelWidth);
          //   doc.text(lines, leftTextX, leftY);
          //   doc.text(formatReadableAmount(Math.abs(item.Balance)), leftAmtX - 5, leftY, { align: "right" });
          //   leftY += lineHeight * lines.length;
          // }
          // doc.setLineWidth(0.5);
          // doc.line(leftAmtX - 70, leftY - 12, leftAmtX + 5, leftY - 12);

          // leftY += 6;

          for (const item of group.items) {
  const lines = doc.splitTextToSize(item.Ac_Name_E.toUpperCase(), labelWidth);
  const requiredHeight = lineHeight * lines.length;

  // 🛑 Check space BEFORE rendering
  if (leftY + requiredHeight > bottomSafeLimit) {
    drawDivider(currentDividerStartY, Math.max(leftY, rightY));
    drawFooter();
    doc.addPage();
    pageCount++;
    leftY = topSafeY;
    rightY = topSafeY;
    drawHeaders();
    currentDividerStartY = leftY;
  }

  doc.text(lines, leftTextX, leftY);
  doc.text(formatReadableAmount(Math.abs(item.Balance)), leftAmtX - 5, leftY, { align: "right" });
  leftY += requiredHeight;
}

        }

        // RIGHT SIDE
        if (rightEntries[i]) {
          const [, group] = rightEntries[i];
          doc.setFont("arial", "bold");
          doc.text(group.items[0].BSGroupName.toUpperCase(), rightTextX, rightY);
          doc.text(formatReadableAmount(Math.abs(group.netgroupvalue) || 0), rightAmtX + 35, rightY, { align: "right" });
          rightY += lineHeight;

          doc.setFont("Arial", "italic");

          let groupStartY = rightY;

          // for (const item of group.items) {
          //   const lines = doc.splitTextToSize(item.Ac_Name_E.toUpperCase(), labelWidth);
          //   doc.text(lines, rightTextX, rightY);
          //   doc.text(formatReadableAmount(Math.abs(item.Balance)), rightAmtX, rightY, { align: "right" });
          //   rightY += lineHeight * lines.length;
          // }

          // doc.setLineWidth(0.5);
          // doc.line(rightAmtX - 70, rightY - 12, rightAmtX + 5, rightY - 12);
          // drawDivider(currentDividerStartY, Math.max(leftY, rightY));

          // rightY += 6;

          for (const item of group.items) {
  const lines = doc.splitTextToSize(item.Ac_Name_E.toUpperCase(), labelWidth);
  const requiredHeight = lineHeight * lines.length;

  // 🛑 Check space BEFORE rendering
  if (rightY + requiredHeight > bottomSafeLimit) {
    drawDivider(currentDividerStartY, Math.max(leftY, rightY));
    drawFooter();
    doc.addPage();
    pageCount++;
    leftY = topSafeY;
    rightY = topSafeY;
    drawHeaders();
    currentDividerStartY = rightY;
  }

  doc.text(lines, rightTextX, rightY);
  doc.text(formatReadableAmount(Math.abs(item.Balance)), rightAmtX, rightY, { align: "right" });
  rightY += requiredHeight;
}

        }
      }
    };


    const drawSummaryRow = (labelL, valueL, labelR, valueR) => {
      checkPageBreak();
      const baseY = Math.max(leftY, rightY);
      leftY = baseY;
      rightY = baseY;

      doc.setFont("Arial", "bold");
      doc.text(labelL, leftTextX, leftY);
      doc.text(formatReadableAmount(valueL), leftAmtX + 35, leftY, { align: "right" });

      doc.text(labelR, rightTextX, rightY);
      doc.text(formatReadableAmount(valueR), rightAmtX + 35, rightY, { align: "right" });

      leftY += lineHeight + 4;
      rightY += lineHeight + 4;
    };

    const drawHorizontalLine = () => {
      const lineY = Math.max(leftY, rightY) - 6;
      doc.setLineWidth(0.75);
      doc.line(margin, lineY - 6, pageWidth - margin, lineY - 6);
    };

    const drawFooter = () => {
      doc.setFontSize(8);
    };

    // Render content
    drawHeaders();
    currentDividerStartY = leftY;
    doc.setFontSize(fontSize);
    renderGroupPairwise(groupedReportData, groupedReportDataRightside);

    const totalPurchase = Object.values(groupedReportData).reduce((a, b) => a + Math.abs(b.groupnetvalue), 0);
    const totalSale = Object.values(groupedReportDataRightside).reduce((a, b) => a + Math.abs(b.netgroupvalue), 0);

    drawSummaryRow("Net Purchase", totalPurchase, "Net Sale", totalSale);
    drawSummaryRow("Gross Profit", Math.max(totalSale - totalPurchase, 0), "Gross Loss", Math.max(totalPurchase - totalSale, 0));
    drawSummaryRow("Total", totalPurchase + (Math.max(totalSale - totalPurchase, 0)), "Total", totalSale + (Math.max(totalPurchase - totalSale, 0)))
    drawSummaryRow("Gross Loss", Math.max(totalPurchase - totalSale, 0), "Gross Profit", Math.max(totalSale - totalPurchase, 0));

    renderGroupPairwise(groupReportDataProfitleftsideDebit, groupReportDataProfitrigthsidetsideCredit);

    const totalExpense = Object.values(groupReportDataProfitleftsideDebit).reduce((a, b) => a + Math.abs(b.groupnetvalue), 0);
    const totalIncome = Object.values(groupReportDataProfitrigthsidetsideCredit).reduce((a, b) => a + Math.abs(b.netgroupvalue), 0);

    const netProfit = (totalSale + totalIncome) - (totalPurchase + totalExpense);

    drawHorizontalLine();
    drawSummaryRow("Total", totalExpense, "Total", totalIncome);
    drawHorizontalLine();
    drawSummaryRow("Net Profit", netProfit > 0 ? netProfit : 0, "Net Loss", netProfit < 0 ? -netProfit : 0);
    drawHorizontalLine();
    drawSummaryRow(
      "Total Debit",
      totalPurchase + totalExpense + (netProfit > 0 ? netProfit : 0),
      "Total Credit",
      totalSale + totalIncome + (netProfit < 0 ? -netProfit : 0)
    );
    drawHorizontalLine();
    drawFooter();
    drawDivider(currentDividerStartY, Math.max(leftY, rightY));

    // Output type
    if (outputType === "blob") {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      setPdfPreview(url);
    } else if (outputType === "print") {
      const dataUri = doc.output("datauristring");
      const printWindow = window.open();
      if (printWindow) {
        printWindow.document.write(`<iframe width='100%' height='100%' src='${dataUri}' frameborder='0'></iframe>`);
        printWindow.document.close();
      }
    }
  };

  const generatePdf = () => renderPdf("blob");
  const handlePrint = () => renderPdf("print");

  function calculateNetResult(
    profitRightSideCreditData,
    profitLeftSideDebitData,
    groupedReportData,
    groupedReportDataRightside,
    threshold = 0
  ) {

    const profitRightSideCreditTotal = Object.values(
      profitRightSideCreditData
    ).reduce((acc, { netgroupvalue }) => acc + Math.abs(netgroupvalue), 0);

    const leftTotal = Object.values(groupedReportData).reduce(
      (acc, { groupnetvalue }) => acc + Math.abs(groupnetvalue),
      0
    );

    const rightTotal = Object.values(groupedReportDataRightside).reduce(
      (acc, { netgroupvalue }) => acc + Math.abs(netgroupvalue),
      0
    );

    const diffRightMinusLeft = rightTotal - leftTotal;

    const resultRight =
      profitRightSideCreditTotal +
      (diffRightMinusLeft > 0 ? diffRightMinusLeft : 0);
    const profitLeftSideDebitTotal = Object.values(
      profitLeftSideDebitData
    ).reduce((acc, { groupnetvalue }) => acc + Math.abs(groupnetvalue), 0);

    const diffLeftMinusRight = leftTotal - rightTotal;
    const resultLeft =
      profitLeftSideDebitTotal +
      (diffLeftMinusRight > 0 ? diffLeftMinusRight : 0);

    const netResult = resultRight - resultLeft;
    return {
      netResult: netResult.toFixed(2),
      isGreaterThanThreshold: netResult > threshold,
    };
  }

  return (
    <div style={{marginTop: "-80px"}}>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{displayCompanyName}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Profit & Loss A/c {groupCode}-{groupName}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>

      <div className="d-flex justify-content-end" style={{ marginTop: "-60px" }}>
        <PrintButton disabledFeild={""} fetchData={handlePrint} />
        <button className="btn btn-success" onClick={handleExportToExcel}>
          Export to Excel
        </button>
        <button onClick={generatePdf} className="btn btn-secondary">
          PDF
        </button>
      </div>

      <div className="table-responsive">
        <table
          className="table table-striped table-bordered mt-4"
          id="reportTable"
          style={{
            width: "100%",
            tableLayout: "fixed",
            marginLeft: "auto",
            marginRight: "auto",
            borderCollapse: "collapse",
          }}
        >
          <thead className="table-light">
            <tr>
              <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#D0E9C6" }}>
                Purchase
              </th>
              <th colSpan={2} style={{ textAlign: "right", backgroundColor: "#D0E9C6" }}>
                Amount
              </th>

              <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#D0E9C6" }}>
                Sale
              </th>
              <th colSpan={2} style={{ textAlign: "right", backgroundColor: "#D0E9C6" }}>
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                align="left"
                colSpan={4}
                style={{
                  verticalAlign: "top",
                  width: "50%",
                  backgroundColor: "#D0E9C6",
                }}
              >
                <table style={{ width: "100%", backgroundColor: "#D0E9C6"}}>
                  <tbody>
                    {Object.entries(groupedReportData).map(
                      ([key, { items, groupnetvalue }]) => {
                        const [millname, BSGroupName] = key.split("-");
                        const filteredItems = items.filter(
                          (item) => item.Balance > 0
                        );
                        const totalGroupBalance = filteredItems
                          .reduce(
                            (sum, item) => sum + Math.abs(item.Balance),
                            0
                          )
                          .toFixed(2);
                        return (
                          <React.Fragment key={key}>
                            <tr className="table-primary">
                              <td
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {millname} - {BSGroupName}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {formatReadableAmount(totalGroupBalance)}
                              </td>
                            </tr>

                            {filteredItems.map((item, index) => {
                              const isLast = index === filteredItems.length - 1;
                              return (
                                <tr
                                  key={index}
                                  // onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                  // style={{cursor: "pointer"}}
                                >
                                  <td
                                  onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                    style={{
                                      textAlign: "left",
                                      whiteSpace: "nowrap",
                                      color: "black",
                                      fontStyle: "italic",
                                      cursor: "pointer"
                                    }}
                                  >
                                    {item.Ac_Name_E}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "right",
                                      color: "black",
                                      paddingRight: "160px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        fontStyle: "normal",
                                        fontWeight: "normal",
                                        borderBottom: isLast ? "2px solid black" : "none",
                                        paddingBottom: "2px",
                                        fontStyle: "italic"
                                      }}
                                    >
                                      {formatReadableAmount(Math.abs(item.Balance))}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}

                          </React.Fragment>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </td>

              <td
                align="left"
                colSpan={4}
                style={{
                  verticalAlign: "top",
                  width: "50%",
                  backgroundColor: "#D0E9C6",
                }}
              >
                <table style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                  <tbody>
                    {Object.entries(groupedReportDataRightside).map(
                      ([key, { items, netgroupvalue }]) => {
                        const [millname, BSGroupName] = key.split("-");
                        const filteredItems = items.filter(
                          (item) => item.Balance < 0
                        );
                        const totalGroupBalance = filteredItems
                          .reduce(
                            (sum, item) => sum + Math.abs(item.Balance),
                            0
                          )
                          .toFixed(2);
                        return (
                          <React.Fragment key={key}>
                            <tr className="table-primary">
                              <td
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {millname} - {BSGroupName}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {formatReadableAmount(totalGroupBalance)}
                              </td>
                            </tr>

                            {/* Sub-items */}
                            {filteredItems.map((item, index) => {
                              const isLast = index === filteredItems.length - 1;
                              return (
                                <tr
                                  key={index}
                                  // onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                  // style={{cursor: "pointer"}}
                                >
                                  <td
                                  onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "10px",
                                      whiteSpace: "nowrap",
                                      color: "black",
                                      fontStyle: "italic",
                                      cursor: "pointer"
                                    }}
                                  >
                                    {item.Ac_Name_E}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "right",
                                      color: "black",
                                      paddingRight: "160px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        borderBottom: isLast ? "2px solid black" : "none",
                                        paddingBottom: isLast ? "2px" : "0",
                                        fontStyle: "italic"
                                      }}
                                    >
                                      {formatReadableAmount(Math.abs(item.Balance))}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}

                          </React.Fragment>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Net Purchase
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {formatReadableAmount(Object.values(groupedReportData)
                        .reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        ))
                      }
                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                  <tr>
                    <td
                      className="fw-bold" style={{ width: "100%", backgroundColor: "#D0E9C6" }}
                    >
                      Net Sale
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "100%", backgroundColor: "#D0E9C6" }}
                      align="right"
                    >
                      {formatReadableAmount(Object.values(groupedReportDataRightside)
                        .reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        ))
                      }
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Gross Profit
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const totalRightSide = Object.values(groupedReportDataRightside).reduce(
                          (acc, { netgroupvalue }) => acc + Math.abs(netgroupvalue),
                          0
                        );
                        const totalLeftSide = Object.values(groupedReportData).reduce(
                          (acc, { groupnetvalue }) => acc + Math.abs(groupnetvalue),
                          0
                        );
                        const difference = totalRightSide - totalLeftSide;

                        return formatReadableAmount(
                          difference > 0 ? difference.toFixed(2) : "0.00"
                        );
                      })()}

                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Gross Loss
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const totalLeftSide = Object.values(groupedReportData).reduce(
                          (acc, { groupnetvalue }) => acc + Math.abs(groupnetvalue),
                          0
                        );
                        const totalRightSide = Object.values(groupedReportDataRightside).reduce(
                          (acc, { netgroupvalue }) => acc + Math.abs(netgroupvalue),
                          0
                        );
                        const difference = totalLeftSide - totalRightSide;

                        return formatReadableAmount(
                          difference > 0 ? difference.toFixed(2) : "0.00"
                        );
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Total
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const leftTotal = Object.values(
                          groupedReportData
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const rightTotal = Object.values(
                          groupedReportDataRightside
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );
                        const diff = rightTotal - leftTotal;
                        const result = leftTotal + (diff > 0 ? diff : 0);
                        return formatReadableAmount(result);
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Total
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {

                        const rightTotal = Object.values(
                          groupedReportDataRightside
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );

                        const leftTotal = Object.values(
                          groupedReportData
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const diff = leftTotal - rightTotal;
                        const result = diff > 0 ? diff : 0;
                        return (formatReadableAmount(rightTotal + result));
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ width: "70%" }}
                      align="left"
                    >
                      Gross Loss
                    </td>
                    <td
                      className="fw-bold"
                      style={{ width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const totalLeftSide = Object.values(groupedReportData).reduce(
                          (acc, { groupnetvalue }) => acc + Math.abs(groupnetvalue),
                          0
                        );
                        const totalRightSide = Object.values(groupedReportDataRightside).reduce(
                          (acc, { netgroupvalue }) => acc + Math.abs(netgroupvalue),
                          0
                        );
                        const difference = totalLeftSide - totalRightSide;

                        return formatReadableAmount(
                          difference > 0 ? difference.toFixed(2) : "0.00"
                        );
                      })()}

                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ width: "70%" }}
                      align="left"
                    >
                      Gross Profit
                    </td>
                    <td
                      className="fw-bold"
                      style={{ width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const totalRightSide = Object.values(groupedReportDataRightside).reduce(
                          (acc, { netgroupvalue }) => acc + Math.abs(netgroupvalue),
                          0
                        );
                        const totalLeftSide = Object.values(groupedReportData).reduce(
                          (acc, { groupnetvalue }) => acc + Math.abs(groupnetvalue),
                          0
                        );
                        const difference = totalRightSide - totalLeftSide;

                        return formatReadableAmount(
                          difference > 0 ? difference.toFixed(2) : "0.00"
                        );
                      })()}

                    </td>
                  </tr>
                </table>
              </td>
            </tr>


            <tr>
              <td align="left" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      {Object.entries(groupReportDataProfitleftsideDebit).map(
                        ([key, { items, groupnetvalue }]) => {
                          const [millname, BSGroupName] = key.split("-");
                          const filteredItems = items.filter(
                            (item) => item.Balance > 0
                          );
                          const totalGroupBalance = filteredItems
                            .reduce(
                              (sum, item) => sum + Math.abs(item.Balance),
                              0
                            )
                            .toFixed(2);
                          return (
                            <React.Fragment key={key}>
                              <tr>
                                <td
                                  className="table-primary header-row"
                                  style={{
                                    width: "30%",
                                    align: "left",
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {millname} - {BSGroupName}
                                </td>
                                <td align="right" style={{ color: "black", fontWeight: "bold", textAlign: "right", paddingLeft: "482px", }}>
                                  {formatReadableAmount(totalGroupBalance)}
                                </td>
                              </tr>

                              {filteredItems.map((item, index) => {
                                const isLast = index === filteredItems.length - 1;
                                return (
                                  <tr
                                    key={index}
                                    // onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                    // style={{cursor: "pointer"}}
                                  >
                                    <td 
                                    onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)} 
                                    style={{ fontStyle: "italic" ,cursor: "pointer"}}>
                                      {item.Balance > 0 ? item.Ac_Name_E : ""}
                                    </td>
                                    <td
                                      align="right"
                                      style={{
                                        paddingRight: "160px",
                                        textAlign: "right",
                                        color: "black",
                                        fontWeight: "normal",
                                        fontStyle: "italic"
                                      }}
                                    >
                                      {item.Balance > 0 ? (
                                        <span
                                          style={{
                                            display: "inline-block",
                                            borderBottom: isLast ? "2px solid black" : "none",
                                            paddingBottom: isLast ? "2px" : "0",
                                            fontStyle: "italic"
                                          }}
                                        >
                                          {formatReadableAmount(Math.abs(item.Balance))}
                                        </span>
                                      ) : ""}
                                    </td>
                                  </tr>
                                );
                              })}

                            </React.Fragment>
                          );
                        }
                      )}
                    </td>
                  </tr>
                </table>
              </td>
              <td align="center" colSpan={4} style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      {Object.entries(
                        groupReportDataProfitrigthsidetsideCredit
                      ).map(([key, { items, netgroupvalue }]) => {
                        const [millname, BSGroupName] = key.split("-");
                        const filteredItems = items.filter(
                          (item) => item.Balance < 0
                        );
                        const totalGroupBalance = filteredItems
                          .reduce(
                            (sum, item) => sum + Math.abs(item.Balance),
                            0
                          )
                          .toFixed(2);
                        return (
                          <React.Fragment key={key}>
                            <tr>
                              <td align="left" style={{ color: "black", fontWeight: "bold", textAlign: "left" }}>

                                {millname} - {BSGroupName}
                              </td>
                              <td align="right" style={{ color: "black", fontWeight: "bold", textAlign: "right", paddingLeft: "482px", }}>

                                {formatReadableAmount(totalGroupBalance)}
                              </td>
                            </tr>

                            {filteredItems.map((item, index) => {
                              const isLast = index === filteredItems.length - 1;
                              return (
                                <tr
                                  key={index}
                                  // onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                  // style={{cursor: "pointer"}}
                                >
                                  <td 
                                  onClick={() => handleRowClick(item.AC_CODE, item.Ac_Name_E)}
                                  style={{ fontStyle: "italic",cursor: "pointer"}}>
                                    {item.Balance < 0 ? item.Ac_Name_E : ""}
                                  </td>
                                  <td
                                    align="right"
                                    style={{
                                      paddingRight: "160px",
                                      textAlign: "right",
                                      color: "black",
                                      fontWeight: "normal",
                                      fontStyle: "italic"
                                    }}
                                  >
                                    {item.Balance < 0 ? (
                                      <span
                                        style={{
                                          display: "inline-block",
                                          borderBottom: isLast ? "2px solid black" : "none",
                                          paddingBottom: isLast ? "2px" : "0"
                                        }}
                                      >
                                        {formatReadableAmount(Math.abs(item.Balance))}
                                      </span>
                                    ) : ""}
                                  </td>
                                </tr>
                              );
                            })}

                          </React.Fragment>
                        );
                      })}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Total
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const profitLeftSideDebitTotal = Object.values(
                          groupReportDataProfitleftsideDebit
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const leftTotal = Object.values(
                          groupedReportData
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const rightTotal = Object.values(
                          groupedReportDataRightside
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );

                        const diff = leftTotal - rightTotal;
                        const result =
                          profitLeftSideDebitTotal + (diff > 0 ? diff : 0);
                        return formatReadableAmount(result);
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Total
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const profitRightSideCreditTotal = Object.values(
                          groupReportDataProfitrigthsidetsideCredit
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );

                        const leftTotal = Object.values(
                          groupedReportData
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const rightTotal = Object.values(
                          groupedReportDataRightside
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );
                        const diff = rightTotal - leftTotal;
                        const result =
                          profitRightSideCreditTotal + (diff > 0 ? diff : 0);

                        return formatReadableAmount(result);
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Net Profit
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const { netResult, isGreaterThanThreshold } =
                          calculateNetResult(
                            groupReportDataProfitrigthsidetsideCredit,
                            groupReportDataProfitleftsideDebit,
                            groupedReportData,
                            groupedReportDataRightside,
                            0
                          );
                        return isGreaterThanThreshold ? ` ${formatReadableAmount(netResult)}` : "";
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Net Loss
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const { netResult, isGreaterThanThreshold } =
                          calculateNetResult(
                            groupReportDataProfitrigthsidetsideCredit,
                            groupReportDataProfitleftsideDebit,
                            groupedReportData,
                            groupedReportDataRightside,
                            0
                          );

                        return !isGreaterThanThreshold
                          ? ` ${formatReadableAmount(Math.abs(netResult))}`
                          : "";
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Total Credit
                    </td>

                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const profitRightSideCreditTotal = Object.values(
                          groupReportDataProfitrigthsidetsideCredit
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );

                        const leftTotal = Object.values(
                          groupedReportData
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const rightTotal = Object.values(
                          groupedReportDataRightside
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );

                        const diff = rightTotal - leftTotal;

                        const result =
                          profitRightSideCreditTotal + (diff > 0 ? diff : 0);
                        const { netResult, isGreaterThanThreshold } =
                          calculateNetResult(
                            groupReportDataProfitrigthsidetsideCredit,
                            groupReportDataProfitleftsideDebit,
                            groupedReportData,
                            groupedReportDataRightside,
                            0
                          );
                        const finalResult =
                          parseFloat(result.toFixed(2)) +
                          (isGreaterThanThreshold < 0
                            ? parseFloat(netResult)
                            : 0);

                        return formatReadableAmount(finalResult);
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
              <td align="left" colSpan={4} style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="left"
                    >
                      Total Debit
                    </td>
                    <td
                      className="fw-bold"
                      style={{ color: "black", width: "70%" }}
                      align="right"
                    >
                      {(() => {
                        const { netResult, isGreaterThanThreshold } =
                          calculateNetResult(
                            groupReportDataProfitrigthsidetsideCredit,
                            groupReportDataProfitleftsideDebit,
                            groupedReportData,
                            groupedReportDataRightside,
                            0
                          );

                        const profitLeftSideDebitTotal = Object.values(
                          groupReportDataProfitleftsideDebit
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const leftTotal = Object.values(
                          groupedReportData
                        ).reduce(
                          (acc, { groupnetvalue }) =>
                            acc + Math.abs(groupnetvalue),
                          0
                        );

                        const rightTotal = Object.values(
                          groupedReportDataRightside
                        ).reduce(
                          (acc, { netgroupvalue }) =>
                            acc + Math.abs(netgroupvalue),
                          0
                        );

                        const diff = leftTotal - rightTotal;

                        const resultLeft =
                          profitLeftSideDebitTotal + (diff > 0 ? diff : 0);

                        // Combine results and return formatted value
                        const finalResult =
                          parseFloat(resultLeft.toFixed(2)) +
                          (isGreaterThanThreshold ? parseFloat(netResult) : 0);

                        return formatReadableAmount(finalResult);
                      })()}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="centered-container">
          {pdfPreview && pdfPreview.length > 0 && (
            <PdfPreview
              pdfData={pdfPreview}
              apiData={reportData}
              label={"ProfitNLoss"}
            />
          )}
        </div>
      </div>
      {loading && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999
        }}>
          <RingLoader size={80} />
        </div>
      )}
    </div>
  );
};

export default ProfitLossReport;
